import BookShow from "components/shared/book/show";
import { getCustomNumberConfig } from "components/shared/form";
import { viewContainer } from "helpers/redux";
import { truckNumber } from "helpers/validators";
import React from "react";
import { config, initialState } from "../form/config";
import Markup from "./markup";

class ShowHiredCar extends BookShow {
    getNumberConfig = (useCustomNumber) => {
        return getCustomNumberConfig({
            number: this.props.config.number,
            useCustomNumber,
            numberValidator: truckNumber,
        });
    };

    getValidationConfig = (state) => ({
        ...this.props.config,
        number: this.getNumberConfig(!!state.useCustomNumber),
    });

    getRequestData = (data) => {
        const { useCustomNumber, ...requestData } = data;
        return requestData;
    };

    get dropdActions() {
        const { canEditBooks } = this.props;
        return canEditBooks ? [{ text: "Удалить", action: this.actionClose }] : [];
    }

    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        source.getItem(match.params).then((data) => {
            data.useCustomNumber = !!truckNumber(data.number).length;
            this.setState({ data, initial: data, ...defParams });
        });
    };

    setCustomNumberMode = ({ value }) => {
        const { data, initial } = this.state;
        const number = value ? data.number : "";
        const nextData = { ...data, number, useCustomNumber: value };
        let shouldUpdate = false;
        for (const key in data) {
            if (initial[key] !== nextData[key]) {
                shouldUpdate = true;
                break;
            }
        }
        const isValid = this.isValidForm(nextData);
        this.setState({ data: nextData, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
    };

    renderBody = () => {
        const { config } = this.props;
        return (
            <Markup
                {...config}
                data={this.state.data}
                setCustomNumberMode={this.props.canEditBooks ? this.setCustomNumberMode : undefined}
                renderField={this.renderField}
                renderSelect={this.renderSelect}
                Button={this.renderButton}
            />
        );
    };
}

const ConfiguredShow = (props) => <ShowHiredCar {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "hired-cars");
